module.exports = __webpack_public_path__ + "static/media/crossing.25a1f2f0.mp3";